'use client';

// «ПАНЕЛЬ РАЗДЕЛА СЕЙЧАС НА ЭКРАНЕ» — один контекст на кабинет.
//
// Разделы кабинета смонтированы одновременно (tab-stack.tsx) и НЕ размонтируются при
// переключении: «показался» ≠ «смонтировался». Активная панель отмечается этим
// контекстом — по нему кнопки уходят в шапку (page-action.tsx) и по нему же
// usePersistentData освежает данные при показе (Р5, владелец 2026-08-21).
//
// Живёт отдельным модулем БЕЗ разметки нарочно: его импортирует библиотечный хук
// (lib/use-persistent-data.ts), а тянуть в него компонент с JSX нельзя — на этом
// спотыкается сборка тестов.
// Провайдера нет (открытый бот, админка) → значение по умолчанию true: поведение вне
// стека прежнее.
import { createContext } from 'react';

export const PaneActiveContext = createContext(true);

/**
 * «ПАНЕЛЬ ВИДНА» — СРОЧНОЕ значение того же признака (ТЗ WEB-CAUSES М42 п.1). PaneActiveContext
 * после тапа по вкладке меняется ОТЛОЖЕННЫМ рендером (tab-stack.tsx, Pane: useDeferredValue) —
 * по нему просыпаются данные и тяжёлые разделы. А куда встают кнопки шапки, полоса папок и
 * строка поиска (порталы page-action / list-head / filter-slot), обязано решиться в ТОМ ЖЕ кадре,
 * что и смена вкладки, иначе кадр показывал бы шапку прежнего раздела. Эти порталы читают этот
 * контекст. Кто глушит раздел (лист «Данных», data-menu.tsx), глушит оба.
 */
export const PaneShownContext = createContext(true);

